import { GetterTree } from 'vuex'
import { RootState, SearchDataInterface } from '@/store/RootState'
import {
  HeaderData,
  Navigation,
  Page,
  Resource,
  StickyPageInterface,
  UserLocation
} from '@/config/interfaces'

export const getters: GetterTree<RootState, RootState> = {
  getMsisdn (state): Resource | null {
    return state.msisdn
  },
  getMsisdns (state): Array<Resource> {
    return state.msisdns
  },
  getMsisdnsBundles (state): Array<Array<Resource>> {
    return state.msisdnsBundles
  },
  getUnreadMessages (state): number {
    return state.unreadMessages
  },
  getHeaderData (state): Array<HeaderData> | null {
    return state.headerData
  },
  getNavigation (state): Navigation | null {
    return state.navigation
  },
  getPageData (state): Array<Page> {
    return state.pageData
  },
  getStickyPage (state): StickyPageInterface | null {
    return state.stickyPage
  },
  getViewState (state): string {
    return state.viewActive
  },
  getViewContent (state): Record<string, unknown> | string {
    return state.viewContent
  },
  getLeftViewState (state): boolean {
    return state.leftViewActive
  },
  getLeftViewContent (state): Record<string, unknown> | string {
    return state.leftViewContent
  },
  getCardBackground (state): string {
    return state.cardBackground
  },
  getLeftViewTitle (state): string {
    return state.leftViewTitle
  },
  getPostParams (state): URLSearchParams | null {
    return state.postParams
  },
  getUserLocation (state): UserLocation | null {
    return state.userLocation
  },
  getToken (state): string {
    return state.token
  },
  getLastLoggedInUser (state): string {
    return state.lastLoggedInUser
  },
  isAuthenticated (state): boolean {
    return !!state.token
  },
  requirePin (state): boolean {
    return state.hasPin
  },
  getCurrentNavigationKey (state): string {
    return state.currentNavigationKey
  },
  isAllowedResend (state): boolean {
    return state.allowResend
  },
  getRefreshLeftView (state): boolean {
    return state.refreshLeftView
  },
  getBillValues (state): Array<string> {
    return state.billValues
  },
  getJumpOnCloseURI (state): string {
    return state.jumpOnCloseURI
  },
  getAudio (state): HTMLAudioElement|null {
    return state.audio
  },
  getRootElClasses (state): string {
    return state.rootElClasses
  },
  getSearchVisible (state): boolean {
    return state.searchVisible
  },
  getSearchData (state): SearchDataInterface|null {
    return state.searchData
  },
  getCurrentUserAvatar (state): string {
    return state.currentUserAvatar
  }
}
